var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(-734.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(253.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(20.000000, -235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15-Copy",
    transform: "translate(433.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(26.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Image-/-brush",
    transform: "translate(1.000000, 4.375000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 17 0 17 17 0 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95833333,11.3333333 C5.34791667,11.3333333 5.66666667,11.6520833 5.66666667,12.0416667 C5.66666667,12.8208333 5.02916667,13.4583333 4.25,13.4583333 C4.12958333,13.4583333 4.01625,13.4441667 3.89583333,13.4229167 C4.11541667,13.0333333 4.25,12.5658333 4.25,12.0416667 C4.25,11.6520833 4.56875,11.3333333 4.95833333,11.3333333 L4.95833333,11.3333333 Z M13.2245833,2.125 C13.0404167,2.125 12.8633333,2.19583333 12.7216667,2.33041667 L6.375,8.67708333 L8.32291667,10.625 L14.6695833,4.27833333 C14.9458333,4.00208333 14.9458333,3.55583333 14.6695833,3.27958333 L13.7204167,2.33041667 C13.57875,2.18875 13.4016667,2.125 13.2245833,2.125 Z M4.95833333,9.91666667 C3.7825,9.91666667 2.83333333,10.8658333 2.83333333,12.0416667 C2.83333333,12.9695833 2.01166667,13.4583333 1.41666667,13.4583333 C2.06833333,14.3225 3.18041667,14.875 4.25,14.875 C5.81541667,14.875 7.08333333,13.6070833 7.08333333,12.0416667 C7.08333333,10.8658333 6.13416667,9.91666667 4.95833333,9.91666667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/art.5e7dada9.svg";
export { ForwardRef as ReactComponent };